import { Component, Input, Output, EventEmitter } from '@angular/core';
import { NgFor, NgIf } from '@angular/common';

interface TableColumn {
  header: string;
  field: string;
  width?: string;
  sortable?: boolean;
}

interface TableRow {
  id: string | number;
  data: any;
  children?: TableRow[];
  expanded?: boolean;
}

@Component({
    selector: 'app-score-drilldown-table-new',
    templateUrl: './score-drilldown-table-new.component.html',
    styleUrl: './score-drilldown-table-new.component.scss',
    imports: [NgFor, NgIf]
})
export class ScoreDrilldownTableNewComponent {
  @Input() columns: TableColumn[] = [
    { header: 'Department', field: 'department', width: '250px' },
    { header: 'Manager', field: 'manager', width: '200px' },
    { header: 'Budget', field: 'budget', width: '150px' },
    { header: 'Status', field: 'status', width: '120px' }
  ];
  
  @Input() data: TableRow[] = [
    {
      id: 1,
      data: {
        department: 'Engineering',
        manager: 'John Smith',
        budget: '$500,000',
        status: 'Active'
      },
      children: [
        {
          id: 2,
          data: {
            department: 'Frontend Development',
            manager: 'Sarah Johnson',
            budget: '$200,000',
            status: 'Active'
          },
          children: [
            {
              id: 3,
              data: {
                department: 'UI/UX Team',
                manager: 'Mike Brown',
                budget: '$100,000',
                status: 'Active'
              },
              children: []
            },
            {
              id: 4,
              data: {
                department: 'React Team',
                manager: 'Lisa Wang',
                budget: '$100,000',
                status: 'Active'
              },
              children: []
            }
          ]
        },
        {
          id: 5,
          data: {
            department: 'Backend Development',
            manager: 'David Lee',
            budget: '$300,000',
            status: 'Active'
          },
          children: [
            {
              id: 6,
              data: {
                department: 'API Team',
                manager: 'Tom Wilson',
                budget: '$150,000',
                status: 'Active'
              },
              children: []
            },
            {
              id: 7,
              data: {
                department: 'Database Team',
                manager: 'Emma Davis',
                budget: '$150,000',
                status: 'Active'
              },
              children: []
            }
          ]
        }
      ]
    },
    {
      id: 8,
      data: {
        department: 'Marketing',
        manager: 'Rachel Green',
        budget: '$300,000',
        status: 'Active'
      },
      children: [
        {
          id: 9,
          data: {
            department: 'Digital Marketing',
            manager: 'Chris Taylor',
            budget: '$150,000',
            status: 'Active'
          },
          children: []
        },
        {
          id: 10,
          data: {
            department: 'Content Marketing',
            manager: 'Anna White',
            budget: '$150,000',
            status: 'Active'
          },
          children: []
        }
      ]
    },
    {
      id: 11,
      data: {
        department: 'Sales',
        manager: 'Michael Scott',
        budget: '$400,000',
        status: 'Active'
      },
      children: [
        {
          id: 12,
          data: {
            department: 'Enterprise Sales',
            manager: 'Jim Halpert',
            budget: '$200,000',
            status: 'Active'
          },
          children: []
        },
        {
          id: 13,
          data: {
            department: 'SMB Sales',
            manager: 'Pam Beesly',
            budget: '$200,000',
            status: 'Active'
          },
          children: []
        }
      ]
    }
  ];
  
  @Input() level: number = 0;
  @Output() rowClick = new EventEmitter<TableRow>();

  toggleRow(row: TableRow) {
    if (row.children && row.children.length > 0) {
      row.expanded = !row.expanded;
    }
  }

  onRowClick(row: TableRow) {
    this.rowClick.emit(row);
  }

  getIndentStyle(level: number): string {
    return `${level * 20}px`;
  }
}
